type Partial<T> = { [P in keyof T]?: Partial<T[P]> };

export class IdentityDto {
  id: string;
  name?: string;
  description?: string;
  code?: string;

  constructor(d?: Partial<IdentityDto>) {
    if (!d) {
      return;
    }

    Object.assign(this, d);
  }
}
